import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import * as S from './Styled';
import Icon from '../../Icon';

// Store
import { logout, profileNav } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';

// Config
import { profile_nav } from '../../../config/profile_nav';

// Utils
import _get from 'lodash/get';

const ProfileNav = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { profileNav: nav } = useSelector(state => state.ui);
  const { auth } = useSelector(state => state);
  const { user } = auth;
  const person = {
    name: _get(user, 'first_name', null),
    email: _get(user, 'email', null),
  };

  const handleClose = () => dispatch(profileNav(false));

  const handleLogout = () => {
    dispatch(profileNav(false));
    dispatch(logout());
  };

  return (
    <>
      <S.ProfileNav visible={nav}>
        <S.CloseBtn onClick={handleClose}>
          <Icon name="close" />
        </S.CloseBtn>
        <S.Content>
          <S.MainWrap>
            {person && (
              <S.User>
                <S.Name>{person.name}</S.Name>
                <S.Email>{person.email}</S.Email>
              </S.User>
            )}
            <S.Section>
              <S.Menu>
                {profile_nav.map(({ id, titleKey, to, icon }) => (
                  <li key={id}>
                    <S.StyledLink to={to} onClick={handleClose}>
                      <S.IconWrap>
                        <Icon name={icon} size="small" />
                      </S.IconWrap>
                      {t(titleKey)}
                    </S.StyledLink>
                  </li>
                ))}
              </S.Menu>
            </S.Section>
          </S.MainWrap>

          <S.SecondaryNav onClick={handleLogout}>
            <S.Logout>{t('labels.log_out')}</S.Logout>
          </S.SecondaryNav>
        </S.Content>
      </S.ProfileNav>
      <S.Overlay visible={nav} onClick={handleClose} />
    </>
  );
};

export default ProfileNav;
